import { GA4Event } from "./GA4Event";

export default buildClickEvent;

function buildClickEvent(model) {
	const { component, interaction, label } = model;
	const event = new GA4Event("click", {
		component: component,
		interaction: interaction,
		label: label
	});
	const { eventData } = event;
	const items = [];
	eventData.params["items"] = items;
	return eventData;
}
